module.exports = __webpack_public_path__ + "static/media/tension6.59518ab2.webp";